import {useState} from "react";
import Donut2 from "../Dashboard/acara/dashboardChart/Donut2";
import SalesChart from "../Dashboard/acara/dashboardChart/Sales";
import ImageComponent from "../shared/ImageComponent";
import {buildImageUrl} from "../../../utils/imageUrlBuilder";
import NoImage from "../../../images/NoImage.jpg";
import LightGallery from "lightgallery/react";
import videoImage from "../../../images/thumbVideo.png";
import lgVideo from "lightgallery/plugins/video";
import lgZoom from "lightgallery/plugins/zoom";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-video.css"; // The video plugin's CSS
import "lightgallery/css/lg-zoom.css"; // The zoom plugin's CSS

import {twMerge} from "tailwind-merge";

const AttachedFiles = ({className, files}) => {
  const [selected, setSelected] = useState({index: 0, ...files[0]});

  return (
    // <div className="col-xl-12 col-sm-6">
    //   <div class="card">
    //     <div class="card-header border-0 pb-0">
    //       <h4 class="fs-20 text-black">Pièces jointes</h4>
    //     </div>

    //     <div class="card-body pt-3 flex flex-col gap-4">

    //     </div>
    //   </div>
    // </div>
    <div className="w-full flex flex-col gap-4 justify-start items-start h-fit bg-white rounded-xl p-4">
      <div className="text-[#19295C] font-semibold text-lg mt-2 ">
        Pièces jointes
      </div>
      {!files || !files.length ? (
        <img
          src={NoImage}
          className="w-full lg:h-[180px] object-cover hidden lg:block rounded-lg"
          alt="no"
        />
      ) : (
        <>
          <LightGallery
            elementClassNames=" grid grid-cols-3 gap-3
            
          "
            plugins={[lgVideo, lgZoom]}
            settings={{
              videojs: true,
              videojsTheme: "city",
              controls: true,
            }}
          >
            {files[0].format === "VIDEO" ? (
              // eslint-disable-next-line jsx-a11y/anchor-is-valid
              <a
                key={files[0].id}
                // href={baseImageUrl + files[0]?.path}
                data-video={`{"source": [{"src": "${buildImageUrl(
                  files[0]?.path,
                )}", "type": "video/mp4"}], "attributes": {"controls": true}}`}
                data-sub-html="<h4>Video Preview</h4>"
                // data-poster={videoImage}
                // data-lg-size="500-300"
                // data-lg-size="1400-1400"
                className=" w-full aspect-square border border-solid border-[#e2e2e2] lg:border-none rounded-xl lg:col-span-3  lg:rounded-lg cursor-pointe "
              >
                <img
                  className=" w-full aspect-square border border-solid border-[#e2e2e2] lg:border-none rounded-xl lg:col-span-3  lg:rounded-lg cursor-pointer"
                  src={videoImage}
                  alt="video thumbnail"
                />
              </a>
            ) : (
              <ImageComponent
                alt={selected?.name}
                className={
                  "w-full aspect-square border border-solid border-[#e2e2e2] lg:border-none rounded-xl  lg:col-span-3 lg:h-[180px] object-cover lg:rounded-lg cursor-pointer"
                }
                src={buildImageUrl("/" + files[0]?.path)}
                fallback={
                  <img
                    src={NoImage}
                    alt=""
                    className="  w-full  object-cover filter brightness-75"
                  />
                }
              />
            )}
            {files.slice(1).map((image, index) => {
              if (index < 2 || files.length === 4) {
                return image.format === "VIDEO" ? (
                  // eslint-disable-next-line jsx-a11y/anchor-is-valid
                  <a
                    key={image.id}
                    data-video={`{"source": [{"src": "${buildImageUrl(
                      image?.path,
                    )}", "type": "video/mp4"}], "attributes": {"controls": true}}`}
                    data-sub-html="<h4>Video Preview</h4>"
                    className=" rounded-xl lg:rounded-lg border border-solid border-[#e2e2e2] min-w-14 w-full aspect-square  object-cover cursor-pointer "
                  >
                    <img
                      className=" rounded-xl lg:rounded-lg border border-solid border-[#e2e2e2] min-w-14 w-full aspect-square  object-cover cursor-pointer"
                      src={videoImage}
                      alt="video thumbnail"
                    />
                  </a>
                ) : (
                  <ImageComponent
                    key={image?.id}
                    src={buildImageUrl(image?.path)}
                    className="rounded-xl lg:rounded-lg border border-solid border-[#e2e2e2] min-w-14 w-full aspect-square  object-cover cursor-pointer "
                    alt={"annonce"}
                    fallback={
                      <img
                        alt="annonce"
                        src={NoImage}
                        className="rounded-xl lg:rounded-lg border border-solid border-[#e2e2e2] min-w-14 w-full  aspect-square object-cover "
                      />
                    }
                  />
                );
              } else if (index === 2 && files.length > 4) {
                return image.format === "VIDEO" ? (
                  // eslint-disable-next-line jsx-a11y/anchor-is-valid
                  <a
                    key={image.id}
                    data-video={`{"source": [{"src": "${buildImageUrl(
                      image?.path,
                    )}", "type": "video/mp4"}], "attributes": {"controls": true}}`}
                    data-sub-html="<h4>Video Preview</h4>"
                    className=" rounded-xl lg:rounded-lg border border-solid border-[#e2e2e2] min-w-14 w-full aspect-square  object-cover cursor-pointer "
                  >
                    <img
                      className=" rounded-xl lg:rounded-lg border border-solid border-[#e2e2e2] min-w-14 w-full aspect-square  object-cover cursor-pointer"
                      src={videoImage}
                      alt="video thumbnail"
                    />
                  </a>
                ) : (
                  <div
                    alt=""
                    src={buildImageUrl(image?.path)}
                    className=" rounded-xl lg:rounded-lg border border-solid border-[#e2e2e2] min-w-14  w-full aspect-square  relative cursor-pointer"
                  >
                    <span className="absolute z-20 font-bold text-lg text-white top-[50%] left-[50%] -translate-x-[50%] -translate-y-[50%] ">
                      {files.length - 4}
                    </span>
                    <ImageComponent
                      key={image?.id}
                      src={buildImageUrl(image?.path)}
                      className=" w-full h-full object-cover rounded-xl lg:rounded-lg filter brightness-50  "
                      alt={"annonce"}
                      fallback={
                        <img
                          alt="annonce"
                          src={NoImage}
                          className="rounded-xl lg:rounded-lg border border-solid border-[#e2e2e2] w-full h-full object-cover filter  brightness-50"
                        />
                      }
                    />
                  </div>
                );
              } else if (index > 2) {
                return (
                  <ImageComponent
                    key={image?.id}
                    src={buildImageUrl(image?.path)}
                    className=" hidden w-full aspect-square object-cover rounded-xl lg:rounded-lg filter brightness-50  "
                    alt={"annonce"}
                    fallback={
                      <img
                        alt="annonce"
                        src={NoImage}
                        className=" hidden rounded-xl lg:rounded-lg border border-solid border-[#e2e2e2] w-full aspect-square object-cover filter  brightness-50"
                      />
                    }
                  />
                );
              }
            })}
          </LightGallery>
        </>
      )}
    </div>
  );
};
export default AttachedFiles;
